import Vue from 'vue';
import Moment from 'moment';
import i18n from '../lang/content.i18n';

export const ScheduleMeeting = Vue.filter('scheduleMeeting', (meeting) => {
  let date = Moment(meeting.endingDate);
  let today = Moment().endOf('day');
  let tomorrow = Moment().add(1, 'day').endOf('day');
  let strStartDate = '';
  let strEndDate = '';

  if(meeting) {
    strStartDate = Moment(meeting.startingDate).format('hh:mma');
    if(date < today || date < tomorrow ){

      strEndDate = date < today ? `${i18n.t('common.to')} ${i18n.t('common.today')} 
                  ${i18n.t('common.at')} ${Moment(meeting.endingDate).format('hh:mma')}` :
                                `${i18n.t('common.to')} ${i18n.t('common.tomorrow')} 
                  ${i18n.t('common.at')} ${Moment(meeting.endingDate).format('hh:mma')}`;

    } else {
      strEndDate = meeting.endingDate ?
          `${i18n.t('common.to')} ${Moment(meeting.endingDate).format('MMM DD, YYYY')}
           ${i18n.t('common.at')} ${Moment(meeting.endingDate).format('hh:mma')}` : '';
    }
  }
  return `${i18n.t('common.from')} ${strStartDate} ${strEndDate}`;
});


